import React, { useState } from 'react'
import { saveAs } from 'file-saver'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'

//UI
import {
  Flex,
  Link,
  SimpleGrid,
  Spacer,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Tooltip,
} from '@chakra-ui/react'

import { FileInput, Input } from '@/components/Form'
import { ConfigType } from '@/features/configs/config.constant'
import useConfig from '@/features/configs/useConfig'
import useFile from '@/features/files/useFile'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

//Hooks

//Hooks

import { FileType } from '@/features/files/constants/FileType'
import VendorHistoryTable from '@/features/vendors/components/VendorHistoryTable'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const VendorUploadTenderDocumentSection = ({ tenderDocuments, history = [], canUpload = false }) => {
  const [tenderDocumentTabIndex, setTenderDocumentTabIndex] = useState(
    canUpload ? tenderDocuments.length - 1 : tenderDocuments.length
  )
  const [vendorViewQuotationDetailModalDetail, setVendorViewQuotationDetailModalDetail] = useState({
    show: false,
    history: {},
  })
  const { t, i18n } = useTranslation()
  const vendorActionHistory = useWatch({ name: 'vendorActionHistory' }) ?? []
  const dispatch = useDispatch()
  const { useDownloadFile } = useFile()
  const downloadFile = useDownloadFile()
  const { useFetchConfigByType } = useConfig()
  const { data: conditionOfPurchaseConfig } = useFetchConfigByType(ConfigType.OFFER_CONDITION_OF_PURCHASE_FILE)

  const handleDownloadAnnex4 = async (event) => {
    event.preventDefault()
    event.stopPropagation()

    const fileId = conditionOfPurchaseConfig?.mainValue

    if (!fileId) {
      toast.error('Condition of Purchase file is not configured yet')
      return
    }

    try {
      dispatch(showLoadingOverlay())

      const response = await downloadFile.mutateAsync(fileId)
      const contentDisposition = response.headers['content-disposition']
      let fileName = 'condition-of-purchase'

      if (contentDisposition && contentDisposition.includes('filename=')) {
        fileName = contentDisposition.split('filename=')[1].replace(/"/g, '')
      }

      const blob = new Blob([response.data], {
        type: response.headers['content-type'],
      })
      saveAs(blob, fileName)
    } catch (err) {
      console.error(err)
      toast.error('Failed to download Condition of Purchase file')
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  return (
    <>
      <Tabs
        size="md"
        colorScheme={'teal'}
        variant="enclosed"
        index={tenderDocumentTabIndex}
        isLazy
        onChange={(index) => {
          setTenderDocumentTabIndex(index)
        }}
      >
        <TabList w="100%">
          {tenderDocuments.map((tenderDocument, tenderDocumentIndex) => {
            const displayName =
              tenderDocumentIndex === 0
                ? t('VENDOR_UPLOAD_PAGE_TENDER')
                : t('VENDOR_UPLOAD_PAGE_ADDENDUM') + tenderDocumentIndex

            return (
              <Tab
                key={'tenderDocumentTab' + tenderDocumentIndex}
                fontWeight={'bold'}
                // _hover={{ color: 'teal' }}
                as={Flex}
                gap="2"
              >
                <Tooltip label={displayName}>
                  <Text>{displayName}</Text>
                </Tooltip>
              </Tab>
            )
          })}
          <Spacer />
          <Tab fontWeight={'bold'}>
            <Tooltip label={'History'}>{t('VENDOR_UPLOAD_PAGE_HISTORY')}</Tooltip>
          </Tab>
        </TabList>
        <TabPanels>
          {tenderDocuments.map((tenderDocument, tenderDocumentIndex) => {
            return (
              <TabPanel key={'tenderDocumentTab' + tenderDocumentIndex}>
                <Flex direction={'column'} gap="2">
                  <SimpleGrid columns={2} spacing={'10px'}>
                    {tenderDocumentIndex === 0 && (
                      <>
                        <FileInput
                          name={`tenderDocuments.${tenderDocumentIndex}.annex1`}
                          label={t('VENDOR_UPLOAD_PAGE_ANNEX_1')}
                          fileType={FileType.SOURCING_ANNEX}
                          isRequired={false}
                          isRow
                          disabled
                        />
                        <FileInput
                          name={`tenderDocuments.${tenderDocumentIndex}.annex2`}
                          label={t('VENDOR_UPLOAD_PAGE_ANNEX_2')}
                          fileType={FileType.SOURCING_ANNEX}
                          isRequired={false}
                          isRow
                          disabled
                        />
                        <FileInput
                          name={`tenderDocuments.${tenderDocumentIndex}.annex3`}
                          label={t('VENDOR_UPLOAD_PAGE_ANNEX_3')}
                          fileType={FileType.SOURCING_ANNEX}
                          isRequired={false}
                          isRow
                          disabled
                        />
                        <Link href={'#'} textDecor={'underline'} color="blue.400" onClick={handleDownloadAnnex4}>
                          {t('VENDOR_UPLOAD_PAGE_ANNEX_4')}
                        </Link>
                      </>
                    )}

                    {Array.isArray(tenderDocument?.otherAnnexs) &&
                      tenderDocument.otherAnnexs.map((other, annexIndex) => (
                        <FileInput
                          key={annexIndex}
                          name={`tenderDocuments.${tenderDocumentIndex}.otherAnnexs.${annexIndex}.files`}
                          label={`${t('VENDOR_UPLOAD_PAGE_OTHER_ANNEX')}: ${other.name}`}
                          fileType={FileType.SOURCING_ANNEX}
                          isRequired={false}
                          isRow
                          disabled
                        />
                      ))}
                  </SimpleGrid>
                  <Input
                    label={t('VENDOR_UPLOAD_PAGE_REMARKS_FROM_SALES_OR_PROCUREMENT')}
                    name={`tenderDocuments.${tenderDocumentIndex}.remark`}
                    isRequired={false}
                    isRow
                    disabled
                  />
                </Flex>
              </TabPanel>
            )
          })}
          <TabPanel>
            <Flex my="3">
              <Text color={'blue.800'} fontWeight={'semibold'} mb="2">
                {t('VENDOR_UPLOAD_PAGE_HISTORY')}
              </Text>
            </Flex>

            <Flex overflow={'scroll'}>
              <VendorHistoryTable
                data={history}
                setVendorViewQuotationDetailModalDetail={setVendorViewQuotationDetailModalDetail}
              />
            </Flex>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  )
}

export default VendorUploadTenderDocumentSection
